import WebFont from 'webfontloader';
import './loader.scss';

// Add the webfont styles
WebFont.load({
  google: {
    families: [
      'Alegreya',
      'Roboto+Condensed:400,700',
      'Source+Sans+Pro:300,400,400i,600,700',
    ],
  },
});



// WEBPACK FOOTER //
// ./app/prb-style-library/index.js